import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CodeSampleTab from './CodeSampleTab';
import CodeSampleContent from './CodeSampleContent';

export default class CodeSample extends Component {

  static propTypes = {
    publicId: PropTypes.string.isRequired,
    transformation: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.arrayOf(PropTypes.object)
    ]).isRequired,
    lang: PropTypes.string,
    setSampleLang: PropTypes.func.isRequired,
    cloudName: PropTypes.string
  };

  static DPR = window.devicePixelRatio || 2;

  static frameworks = [
    { name: 'url', icon: `https://res.cloudinary.com/cloudinary/image/upload/c_fit,w_60,h_40/dpr_${CodeSample.DPR}/framework_url.png` },
    { name: 'ruby', icon: `https://res.cloudinary.com/cloudinary/image/upload/c_fit,h_40,w_60/dpr_${CodeSample.DPR}/framework_rails.png` },
    { name: 'php', icon: `https://res.cloudinary.com/cloudinary/image/upload/c_fit,h_40,w_60/dpr_${CodeSample.DPR}/framework_php.png` },
    { name: 'node', language: 'javascript', icon: `https://res.cloudinary.com/cloudinary/image/upload/c_fit,h_40,w_60/dpr_${CodeSample.DPR}/framework_node.png` },
    { name: 'python', icon: `https://res.cloudinary.com/cloudinary/image/upload/c_fit,h_40,w_60/dpr_${CodeSample.DPR}/framework_django.png` },
    { name: 'jquery', language: 'javascript', icon: `https://res.cloudinary.com/cloudinary/image/upload/c_fit,h_40,w_60/dpr_${CodeSample.DPR}/framework_jquery.png` },
    { name: 'angular', language: 'xml', icon: `https://res.cloudinary.com/cloudinary/image/upload/c_fit,h_40,w_60/dpr_${CodeSample.DPR}/framework_angular.png` },
    { name: 'java', icon: `https://res.cloudinary.com/cloudinary/image/upload/c_fit,h_40,w_60/dpr_${CodeSample.DPR}/framework_java.png` },
    { name: 'csharp', icon: `https://res.cloudinary.com/cloudinary/image/upload/c_fit,h_40,w_60/dpr_${CodeSample.DPR}/framework_dotnet.png` },
    { name: 'scala', icon: `https://res.cloudinary.com/cloudinary/image/upload/c_fit,h_40,w_60/dpr_${CodeSample.DPR}/framework_scala.png` },
    { name: 'android', language: 'java', icon: `https://res.cloudinary.com/cloudinary/image/upload/c_fit,h_40,w_60/dpr_${CodeSample.DPR}/framework_android.png` }
  ];

  render() {
    return (
      <div className="tab-block">
        <ul className="tabset">
          {CodeSample.frameworks.map(f => <CodeSampleTab setSampleLang={this.props.setSampleLang} selected={this.props.lang == f.name} key={f.name} name={f.name} icon={f.icon} />)}
        </ul>
        <div className="tab-content">
          {CodeSample.frameworks.map(f => <CodeSampleContent {...this.props} selected={this.props.lang == f.name} key={f.name} name={f.name} language={f.language || f.name} cloudName={this.props.cloudName} />)}
        </div>
      </div>
    );
  }
}








/** WEBPACK FOOTER **
 ** ./src/js/components/CodeSample/CodeSample.js
 **/